import { ACCORDIAN_INDEX, PAGE_LOADER } from "./actionTypes"

export const togglePageLoader = message => {
  return {
    type: PAGE_LOADER,
    payload: message,
  }
}

export const maintainSelectedIndex = data => {
  
  return {
    type: ACCORDIAN_INDEX,
    payload: data,
  }
}
